import React from 'react';
import LoggerAdapter from './LoggerAdapter';
import AbstractTrackingAdapter from './AbstractTrackingAdapter';

const logger = new LoggerAdapter();

const TrackingContext = React.createContext<AbstractTrackingAdapter>(logger);

export default TrackingContext;
